import { ISurvey, ISurveyComponent, ISurveyInfo, ITransporter, IUxSchema, SurveyComponentType, SurveyType } from "@ms-ofb/floodgate-shared-typings";
import { FloodgateEngine } from "../FloodgateEngine";
import * as Utils from "./../Utils";

export abstract class Survey implements ISurvey {
	private survey: ISurvey;
	private clientFeedbackId: string;
	private uxSchema: IUxSchema

	public abstract getComponent(componentType: SurveyComponentType): ISurveyComponent;

	public getCampaignId(): string {
		return this.getSurveyInfo().getBackEndId();
	}

	public getLauncherType(): string {
		return this.getSurveyInfo().getLauncherType();
	}

	public getClientFeedbackId(): string {
		return this.clientFeedbackId;
	}

	// @Override
	public getTags(): string[] {
		return this.getSurveyInfo().getTags();
	}

	public async submit(): Promise<void> {
		const surveyType: string = SurveyType[this.getType()];
		const transporter: ITransporter = FloodgateEngine.getTransportFactory().makeTransporter(surveyType);
		transporter.setManifestValues(this.getJsonElements());
		this.clientFeedbackId = transporter.getClientFeedbackId();
		return transporter.submit();
	}

	public getPreGeneratedClientFeedbackId(): string {
		if (this.clientFeedbackId) {
			return this.clientFeedbackId;
		} else {
			return this.clientFeedbackId = Utils.guid();
		}
	}
	
	public getUxSchema(): IUxSchema {
		return this.uxSchema;
	}
	
	public setUxSchema(inputSchema: IUxSchema) {
		this.uxSchema = inputSchema;
	}
	
	public isContentValid(): boolean {
		return true;
	}

	// Abstract classes that are implemented by actual Surveys
	public abstract getType(): SurveyType;

	public abstract getSurveyInfo(): ISurveyInfo;

	public abstract getJsonElements(): object;

	public abstract getDomElements(doc: Document): Element[];
}
